export enum FileSensitivity {
  PUBLIC = 'Public',
  CONFIDENTIAL = 'Confidential',
  HIGHLY_CONFIDENTIAL = 'Highly Confidential',
  PRIVATE_CONFIDENTIAL = 'Private Confidential',
}
